/**
 * 文章列表（与 web/src/api/news.js 对齐）：api/index/getList
 */
import { fetchWithAuth } from '../utils/request.js';
import { getApiUrl, BACKEND_ORIGIN } from '../config/api.js';

function toCaseBackground(img) {
  if (img == null || String(img).trim() === '') {
    return 'linear-gradient(180deg, #e8eaef 0%, #dde1e8 100%)';
  }
  const s = String(img).trim();
  let absolute = s;
  if (/^https?:\/\//i.test(s)) {
    absolute = s;
  } else if (s.startsWith('//')) {
    absolute = `https:${s}`;
  } else {
    absolute = `${BACKEND_ORIGIN}${s.startsWith('/') ? '' : '/'}${s}`;
  }
  return `url(${absolute})`;
}

function mapToCaseCard(item, index) {
  const id = item.id ?? item.articleId ?? item.article_id ?? index;
  const title = item.title ?? '';
  const content = item.content ?? '';
  const summary = content.length > 80 ? `${content.slice(0, 80)}...` : content;
  const img = item.images ?? item.img ?? item.cover ?? '';
  return {
    id,
    lanhuBg2: toCaseBackground(img),
    lanhutext0: title,
    lanhutext1: summary,
    lanhutext2: '查看详情'
  };
}

/**
 * @param {number} [page=1]
 * @param {number} [size=10]
 */
export async function getArticleList(page = 1, size = 10) {
  const base = getApiUrl('list');
  const url = `${base}${base.includes('?') ? '&' : '?'}page=${page}&size=${size}`;
  const res = await fetchWithAuth(url);
  const json = await res.json();
  const codeOk =
    json.code === 200 || json.code === '200' || Number(json.code) === 200;
  if (!codeOk) {
    return {
      list: [],
      success: false,
      message: json.message || '获取列表失败'
    };
  }
  const data = json.data ?? json;
  const rawList =
    data?.list ?? data?.records ?? data?.rows ?? (Array.isArray(data) ? data : []);
  const list = rawList ?? [];
  const arr = Array.isArray(list) ? list : [];
  const mapped = arr.map((it, i) => mapToCaseCard(it, i));
  return {
    list: mapped,
    success: true,
    total: data?.total ?? mapped.length,
    page: data?.page ?? page,
    size: data?.size ?? size
  };
}
